import React, { useState, useEffect } from "react";
import BaseEmailComponent from "../BaseEmailComponent";
import EmailImageUpload from "../EmailImageUpload";
import { Form } from "react-bootstrap";

const ImageTextFeature = ({ id, data, onUpdate, styleSettings }) => {
  const [image, setImage] = useState(data?.image || null);

  // Update image when data changes
  useEffect(() => {
    if (data) {
      setImage(data.image || null);
    }
  }, [data]);

  // Handle image update
  const handleImageUpload = (imageData) => {
    setImage(imageData);
  };

  // Edit UI with forms and image upload
  const renderEditUI = ({ title, setTitle, description, setDescription, handleSaveChanges, styleSettings }) => {
    // Function to save all changes at once
    const saveAllChanges = () => {
      handleSaveChanges(title, description, { image });
    };

    return (
      <div className="row p-3 rounded" style={{ backgroundColor: 'white' }}>
        <div className="col-md-5">
          <EmailImageUpload
            initialImage={image}
            onImageUpload={handleImageUpload}
            allowRegenerate={true}
            label="Feature Image"
          />
        </div>
        <div className="col-md-7">
          <Form.Group className="mb-3">
            <Form.Label><strong>Title</strong></Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onBlur={saveAllChanges}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label><strong>Description</strong></Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onBlur={saveAllChanges}
            />
          </Form.Group>
        </div>
      </div>
    );
  };

  // View UI for display mode
  const renderViewUI = ({ title, description, styleSettings }) => {
    const { primaryColor, secondaryColor, fontFamily } = styleSettings || {};

    return (
      <div className="row">
        <div className="col-md-5">
          <div className="rounded p-2 d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
            {image ? (
              <img src={image} alt="Feature" className="img-fluid rounded" />
            ) : (
              <div className="d-flex align-items-center justify-content-center h-100 outline-none rounded">
                <img
                  src="/img-preview.svg"
                  alt="Feature placeholder"
                  className="img-fluid rounded"
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-md-7">
          <div>
            <h3 style={{ 
              fontSize: "22px", 
              marginBottom: "10px",
              color: primaryColor || "#333333",
              fontFamily
            }}>
              {title}
            </h3>
            <p className="description-text" style={{ 
              fontFamily,
              color: "#666666"
            }}>
              {description}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <BaseEmailComponent
      id={id}
      data={data}
      onUpdate={onUpdate}
      componentName="Image with Text Feature"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
    />
  );
};

export default ImageTextFeature; 